import { render, staticRenderFns } from "./CursoRealizadoCard.vue?vue&type=template&id=4a8a19d9&scoped=true"
import script from "./CursoRealizadoCard.vue?vue&type=script&lang=js"
export * from "./CursoRealizadoCard.vue?vue&type=script&lang=js"
import style0 from "./CursoRealizadoCard.vue?vue&type=style&index=0&id=4a8a19d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8a19d9",
  null
  
)

export default component.exports